import {
    collection,
    addDoc,
    query,
    where,
    getDocs,
    doc,
    getDoc,
    updateDoc,
    deleteDoc,
    serverTimestamp
} from 'firebase/firestore';
import { db } from '../config/firebase';

export const reservationService = {
    /**
     * Créer une réservation
     */
    async createReservation(userId, reservationData) {
        try {

            const services = {
                coupe: { name: 'Coupe de cheveux', price: 25, duration: 30 },
                coloration: { name: 'Coloration', price: 50, duration: 60 },
                lissage: { name: 'Lissage brésilien', price: 80, duration: 90 },
                extension: { name: 'Extensions', price: 100, duration: 120 },
            };

            const service = services[reservationData.service];

            const newReservation = {
                userId,
                service: reservationData.service,
                serviceName: service.name,
                date: reservationData.date,
                time: reservationData.time,
                duration: service.duration,
                price: service.price,
                notes: reservationData.notes || '',
                status: 'pending',
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp(),
            };

            const reservationsRef = collection(db, 'reservations');
            const docRef = await addDoc(reservationsRef, newReservation);

            return {
                id: docRef.id,
                ...newReservation,
            };
        } catch (error) {
            console.error('[reservationService] Erreur création:', error);
            throw error;
        }
    },


    /**
     * Récupérer les réservations d'un utilisateur
     */
    async getUserReservations(userId) {
        try {

            const reservationsRef = collection(db, 'reservations');
            const q = query(reservationsRef, where('userId', '==', userId));
            const querySnapshot = await getDocs(q);

            const reservationsList = [];
            querySnapshot.forEach((doc) => {
                reservationsList.push({
                    id: doc.id,
                    ...doc.data(),
                });
            });

            return reservationsList;
        } catch (error) {
            console.error('[reservationService] Erreur récupération:', error);
            throw error;
        }
    },

    /**
 * Récupérer UNE réservation par ID
 */
    async getReservationById(reservationId) {
        try {

            const reservationDocRef = doc(db, 'reservations', reservationId);
            const reservationDocSnap = await getDoc(reservationDocRef);

            if (reservationDocSnap.exists()) {
                const reservation = {
                    id: reservationDocSnap.id,
                    ...reservationDocSnap.data(),
                };


                return reservation;
            } else {

                return null;
            }
        } catch (error) {
            console.error('[reservationService] Erreur:', error);
            throw error;
        }
    },


    /**
     * Annuler une réservation
     */
    async cancelReservation(reservationId) {
        try {

            const reservationDocRef = doc(db, 'reservations', reservationId);
            await updateDoc(reservationDocRef, {
                status: 'annulée',
                updatedAt: serverTimestamp(),
            });

        } catch (error) {
            console.error('[reservationService] Erreur annulation:', error);
            throw error;
        }
    },

    /**
     * Supprimer une réservation
     */
    async deleteReservation(reservationId) {
        try {

            const reservationDocRef = doc(db, 'reservations', reservationId);
            await deleteDoc(reservationDocRef);

        } catch (error) {
            console.error('[reservationService] Erreur suppression:', error);
            throw error;
        }
    },

    /**
 * Récupérer TOUTES les réservations (pour l'admin)
 */
    /**
 * Récupérer TOUTES les réservations avec infos client
 */
    async getAllReservations() {
        try {

            const reservationsRef = collection(db, 'reservations');
            const querySnapshot = await getDocs(reservationsRef);

            const reservationsList = [];

            // Utiliser docSnap au lieu de doc pour éviter le conflit
            for (const docSnap of querySnapshot.docs) {
                const data = docSnap.data();

                // Récupérer les infos du client
                let clientInfo = {
                    clientName: 'Client inconnu',
                    clientEmail: 'Email inconnu',
                    clientPhone: 'Téléphone inconnu',
                };

                if (data.userId) {
                    try {
                        const userDocRef = doc(db, 'users', data.userId);
                        const userSnapshot = await getDoc(userDocRef);

                        if (userSnapshot.exists()) {
                            const userData = userSnapshot.data();
                            clientInfo = {
                                clientName: userData.name || 'Client inconnu',
                                clientEmail: userData.email || 'Email inconnu',
                                clientPhone: userData.phone || 'Téléphone inconnu',
                            };

                        }
                    } catch (error) {
                        console.warn('[reservationService] Erreur récupération client:', error);
                    }
                }

                reservationsList.push({
                    id: docSnap.id,
                    ...data,
                    ...clientInfo,
                    serviceName: data.serviceName || 'Service inconnu',
                    status: data.status || 'pending',
                });
            }

            return reservationsList;
        } catch (error) {
            console.error('[reservationService] Erreur récupération:', error);
            throw error;
        }
    },



    /**
 * Mettre à jour une réservation
 */
    async updateReservation(reservationId, data) {
        try {

            const reservationDocRef = doc(db, 'reservations', reservationId);
            await updateDoc(reservationDocRef, {
                ...data,
                updatedAt: serverTimestamp(),
            });

        } catch (error) {
            console.error('[reservationService] Erreur mise à jour:', error);
            throw error;
        }
    }

};
